import React, { useState } from 'react';
import axios from 'axios';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import PropTypes from 'prop-types';
import './login-view.scss';
import { Link } from "react-router-dom";


function LoginView(props){
    const [username, setUsername] = useState('');
    const [password, setPassword] =useState('');
    // Declare hook for each input
    const [ usernameErr, setUsernameErr ] = useState('');
    const [ passwordErr, setPasswordErr ] = useState('');

    // validate user inputs
    const validate = () => {
        let isReq = true;
        if(!username){
        setUsernameErr('Username Required');
        isReq = false;
        }else if(username.length < 5){
        setUsernameErr('Username must be atleast 5 characters long');
        isReq = false;
        }
        if(!password){
        setPasswordErr('Password Required');
        isReq = false;
        }else if(password.length < 6){
        setPassword('Password must be 6 characters long');
        isReq = false;
        }

        return isReq;
    }

    const handleSubmit=(e)=>{
        e.preventDefault();
        const isReq = validate();
        if(isReq) {
          /* Send request to the server for authentication */
          axios.post('https://movieapi-production-2da7.up.railway.app/login', {
              Username: username,
              Password: password
          })
          .then(response =>{
              const data = response.data;
              console.log(data)
              props.onLoggedIn(data);
          })
          .catch(e => {
            console.log('no such user')
          });
        }
    }

    const handleDemoRegistration=(e)=>{
           if(true) {
          /* Send request to the server for authentication */
          axios.post('https://movieapi-production-2da7.up.railway.app/login', {
              Username: 'User1',
              Password: 'DemoUser19190!'
          })
          .then(response =>{
              const data = response.data;
              props.onLoggedIn(data);
          })
          .catch(e => {
            console.log('no such user')
          });
        }
        }

    return(
        <Form>
            <Form.Group>
                <Form.Label>Username:</Form.Label>
                <Form.Control type="text" value={username} onChange={e=>setUsername(e.target.value)} />
                {/* code added here to display validation error */}
                {usernameErr && <p>{usernameErr}</p>}
            </Form.Group>
            <Form.Group>
                <Form.Label>Passwort:</Form.Label>
                <Form.Control type="password" value={password} onChange={e=>setPassword(e.target.value)} />
                 {/* code added here to display validation error */}
                {passwordErr && <p>{passwordErr}</p>}
            </Form.Group>
            <Button variant="success" type='submit' onClick={handleSubmit}>Anmelden</Button>
            <span style={{ margin: '0 3px' }}></span>
            <Button variant="success"  onClick={handleDemoRegistration} className="ms-2" >Als Demo Anmelden</Button><br></br>
            <span className='px-0'>
                Noch kein konto?
                <Link to={`/myFlix_client/register`} >
                    <Button  type='submit' variant="link" className='btn px-1 pt-0 mt-0'>Registieren</Button>
                </Link>
            </span>
        </Form>
    );

}

LoginView.propTypes = {
    onLoggedIn: PropTypes.func.isRequired
  };

export default LoginView